<template>
  <button
    class="pushable"
    :type="nativeType"
    :class="[
      btnStyle === 'box' ? 'box-btn' : '',
      bgColor === 'color' ? 'bg-color' : '',
    ]"
    @click="itserveButtonClicked"
  >
    <span class="shadow"></span>
    <span class="edge"></span>
    <span class="front" :class="icon ? 'icon-inside' : 'no-icon'">
      <div class="btn-icon-wraper" :class="icon ? 'icon-inside' : 'no-icon'">
        <div
          class="nav-btn-icon"
          :class="newsIcon ? 'news-icon' : ''"
          v-if="icon"
          :style="{ backgroundColor: iconColor }"
        >
          <slot></slot>
        </div>
      </div>

      <template v-if="newsIcon">
        <div class="btn-content icon-inside news-icon-content">
          {{ value }}
          <template v-if="animated">
            <v-icon name="hand-pointer" class="animated-pointer-icon"></v-icon>
          </template>
        </div>
      </template>

      <template v-else>
        <div class="btn-content" :class="icon ? 'icon-inside' : 'no-icon'">
          {{ value }}
          <template v-if="animated">
            <v-icon name="hand-pointer" class="animated-pointer-icon"></v-icon>
          </template>
        </div>
      </template>
    </span>
  </button>
</template>

<script>
import "vue-awesome/icons/hand-pointer";

export default {
  name: "itserve-button",
  props: {
    value: {
      type: String,
      default: "",
    },
    nativeType: {
      type: String,
      default: "button", // ✅ по умолчанию кнопка, а не submit
    },
    icon: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: "",
    },
    btnStyle: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "",
    },
    newsIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    itserveButtonClicked(e) {
      // событие для интеграции с native, если есть
      if (this.nativeSendEvent) {
        this.nativeSendEvent("bottomBar", {});
      }
      // эмитим наружу
      this.$emit("click", e);
    },
  },
};
</script>

<style scoped>
.box-btn .btn-icon-wraper,
.box-btn .nav-btn-icon {
  display: inline-block !important;
}

.pushable {
  position: relative;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  outline-offset: 4px;
  transition: filter 250ms;
}

/* ЭТОТ БЛОК СКРЫВАЕТ ТЕНЬ */
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: hsl(0deg 0% 0% / 0.35);
  will-change: transform;
  transform: translateY(2px);
  transition: transform 600ms cubic-bezier(0.3, 0.7, 0.4, 1);
  display: none; /* <--- ДОБАВЛЕНО */
}

/* ЭТОТ БЛОК СКРЫВАЕТ ГРАНЬ */
.edge {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  display: none; /* <--- ДОБАВЛЕНО */
}

.btn-content {
  height: 50px;
  line-height: 50px;
}

.news-icon {
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  position: absolute;
  margin-top: 8px;
  text-align: center;
  margin-left: 10px;
  background-color: transparent !important;
  border: 2px solid red !important;
}

.news-icon-content {
}

/* ЭТОТ БЛОК ВЫРАВНИВАЕТ КНОПКУ */
.front {
  display: block;
  position: relative;
  border-radius: 12px;
  font-size: 18px;
  color: white;
  background: #4277f5 !important;
  will-change: transform;
  transform: none; /* <--- ИЗМЕНЕНО */
  transition: none; /* <--- ИЗМЕНЕНО */
}

.pushable:hover {
  filter: brightness(110%);
}

/* ЭТИ БЛОКИ УБИРАЮТ АНИМАЦИЮ */
.pushable:hover .front {
  transform: none; /* <--- ИЗМЕНЕНО */
  transition: none;
}

.pushable:active .front {
  transform: none; /* <--- ИЗМЕНЕНО */
  transition: none;
}

.pushable:hover .shadow {
  transform: translateY(4px);
  transition: transform 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
}

.pushable:active .shadow {
  transform: translateY(1px);
  transition: transform 34ms;
}

.pushable:focus:not(:focus-visible) {
  outline: none;
}

.bg-colot {
  background-color: #001526;
}
</style>
